import { Box, IconButton, Typography } from "@mui/material";
import { MdKeyboardArrowRight } from "react-icons/md";
import numberFormat from "../../../components/globalFunction/prettierNumber";

const RegionComponent = ({ data, action }) => {
  const calculateTotalPrice = (data) => {
    let total = 0;
    if (!data) return 0;
    data.forEach((e) => {
      e.products.forEach((e) => {
        total += e.amount * e.price;
      });
    });
    return total === 0 ? 0 : numberFormat(total);
  };
  const calculateTotalAmount = (data) => {
    let total = 0;
    if (!data) return 0;
    data.forEach((e) => {
      total += e.amountPayment * 1;
    });
    return total === 0 ? 0 : numberFormat(total);
  };
  const calculateTotalFact = (data) => {
    let total = 0;
    if (!data) return 0;
    data.forEach((e) => {
      e.createdOrder.products.forEach((e) => {
        total += e.amount * e.price;
      });
    });
    return total === 0 ? 0 : numberFormat(total);
  };
  return (
    <>
      {data.map((e, i) => (
        <Box
          key={i}
          sx={{
            borderBottom: "1px solid #ccc",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "background.paper",
            padding: "10px",
            transition: "all 0.3s ease",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "action.hover",
              borderColor: "primary.main",
            },
          }}
          role="button"
          onClick={() => {
            action("Manager", e);
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
              width: "100%",
            }}
          >
            <Box
              width={"100%"}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30px",
                  height: "30px",
                  backgroundColor: "rgba(3, 134, 129, 0.22)",
                  borderRadius: "50%",
                }}
              >
                <Typography>{i + 1}</Typography>
              </Box>
              <Typography>{e.region.name}</Typography>
            </Box>
            <Box width={"100%"}>
              <Typography textAlign={"center"}>{e.managers.length}</Typography>
            </Box>
            <Box width={"100%"}>
              <Typography textAlign={"center"}>{e.orders.length}</Typography>
            </Box>
            <Box width={"100%"}>
              <Typography textAlign={"center"} fontWeight={"bold"}>
                {calculateTotalPrice(e.orders)}
              </Typography>
            </Box>
            <Box width={"100%"}>
              <Typography textAlign={"center"} fontWeight={"bold"}>
                {calculateTotalAmount(e.orders)}
              </Typography>
            </Box>
            <Box width={"100%"}>
              <Typography textAlign={"center"} fontWeight={"bold"}>
                {calculateTotalFact(e.orders)}
              </Typography>
            </Box>
          </Box>
          <IconButton>
            <MdKeyboardArrowRight />
          </IconButton>
        </Box>
      ))}
    </>
  );
};

export default RegionComponent;
